export default [
    {
        path: '/admin/pension-contribution-wage',
        name: 'pension-contribution-wage',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/pension-contribution-wage/index.vue')
    }
]